import React, { useContext } from 'react';
import { BellWrapper, BellIcon, NotSeenWrapper } from './Bell.styled';
import { getAmountOfNotSeenMessages } from '../../helpers/getAmountOfNotSeenMessages';
import { getBellColor } from './helpers/getBellColor';
import { AuthContext } from '@/common/contexts/authContext';


const Bell = ({ setIsTicketsViewOpen, tickets }) => {
	const { authUser } = useContext(AuthContext);

	const currentUserId = authUser.id;
	const amount = getAmountOfNotSeenMessages(tickets, currentUserId);
	const color = getBellColor(amount);
	
	return (
		<BellWrapper
			onClick={() => setIsTicketsViewOpen(() => true)}
			className='animation-scale'
			color={color}
		>
			<BellIcon
				color={color}
				name='bell'
			/>
			{!!amount && (
				<NotSeenWrapper>{amount}</NotSeenWrapper>
			)}
		</BellWrapper>
	);
};

export default Bell;
